import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BookingPage from "../pages/booking/page";
import TherapistsPage from "../pages/therapists/page";
import ReviewsPage from "../pages/reviews/page";
import ProfilePage from "../pages/profile/page";
import OrdersPage from "../pages/orders/page";
import OrderConfirmPage from "../pages/order-confirm/page";
import CancelReasonPage from "../pages/cancel-reason/page";
import TherapistDetailPage from "../pages/therapist-detail/page";
import CitySelectPage from "../pages/city-select/page";
import ServiceDetailPage from "../pages/service-detail/page";
import ProfileEditPage from "../pages/profile-edit/page";
import AssistantPage from "../pages/assistant/page";
import AddressPage from "../pages/address/page";
import CouponsPage from "../pages/coupons/page";
import WalletPage from "../pages/wallet/page";
import ServicePage from "../pages/service/page";
import SupportChatPage from "../pages/support-chat/page";
import FeedbackPage from "../pages/feedback/page";
import LoginPage from "../pages/login/page";
import FollowedTherapistsPage from "../pages/followed-therapists/page";
import AgreementPage from "../pages/agreement/page";
import RequireBoundMobile from "@/components/feature/RequireBoundMobile";
import TherapistDetailRouteAlias from "./TherapistDetailRouteAlias";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/agreement", element: <AgreementPage /> },
  { path: "/booking", element: <BookingPage /> },
  { path: "/therapists", element: <TherapistsPage /> },
  { path: "/therapist/:id", element: <TherapistDetailRouteAlias /> },
  { path: "/therapist-detail", element: <RequireBoundMobile scene="therapist"><TherapistDetailPage /></RequireBoundMobile> },
  { path: "/reviews", element: <ReviewsPage /> },
  { path: "/profile", element: <RequireBoundMobile scene="profile"><ProfilePage /></RequireBoundMobile> },
  { path: "/orders", element: <RequireBoundMobile scene="orders"><OrdersPage /></RequireBoundMobile> },
  { path: "/order-confirm", element: <OrderConfirmPage /> },
  { path: "/cancel-reason", element: <CancelReasonPage /> },
  { path: "/city-select", element: <CitySelectPage /> },
  { path: "/service-detail", element: <ServiceDetailPage /> },
  { path: "/profile-edit", element: <ProfileEditPage /> },
  { path: "/assistant", element: <RequireBoundMobile scene="assistant"><AssistantPage /></RequireBoundMobile> },
  { path: "/address", element: <AddressPage /> },
  { path: "/coupons", element: <CouponsPage /> },
  { path: "/wallet", element: <WalletPage /> },
  { path: "/service", element: <ServicePage /> },
  { path: "/support-chat", element: <SupportChatPage /> },
  { path: "/feedback", element: <FeedbackPage /> },
  { path: "/followed-therapists", element: <FollowedTherapistsPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
